import axios from 'axios';

const getNotasPage = params => axios.get('tipos-notas-entradas', {
  params,
});

export default {
  getNotasPage,
};
